// THIS IS A GENERATED FILE
import * as Types from '@gatsbyjs/graphql/types';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
import { useApolloFragment } from 'apollo-fragment-react';


export type MerlinSourceEventFragment = (
  { __typename?: 'MerlinSourceEvent' }
  & Pick<Types.MerlinSourceEvent, 'id' | 'status' | 'createdAt' | 'endedAt' | 'resourceId' | 'resourceType' | 'cmsVendor' | 'isFullSource' | 'tagName'>
);

export type MerlinSourceEventByIdQueryVariables = Types.Exact<{
  sourceEventId: Types.Scalars['ID'];
}>;


export type MerlinSourceEventByIdQuery = (
  { __typename?: 'Query' }
  & { merlinSourceEventById?: Types.Maybe<(
    { __typename?: 'MerlinSourceEvent' }
    & MerlinSourceEventFragment
  )> }
);

export type ActiveCmsIntegrationsForSiteQueryVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
}>;


export type ActiveCmsIntegrationsForSiteQuery = (
  { __typename?: 'Query' }
  & { activeCmsIntegrationsForSite?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'CmsIntegration' }
    & Pick<Types.CmsIntegration, 'id' | 'resourceId' | 'vendor' | 'status' | 'config' | 'environmentVariablesFeatureStatus' | 'webhookFeatureStatus' | 'extensionFeatureStatus'>
  )>>> }
);

export const MerlinSourceEventFragmentDoc = gql`
    fragment MerlinSourceEvent on MerlinSourceEvent {
  id
  status
  createdAt
  endedAt
  resourceId
  resourceType
  cmsVendor
  isFullSource
  tagName
}
    `;
export const MerlinSourceEventByIdDocument = gql`
    query MerlinSourceEventById($sourceEventId: ID!) {
  merlinSourceEventById(sourceEventId: $sourceEventId) {
    ...MerlinSourceEvent
  }
}
    ${MerlinSourceEventFragmentDoc}`;

/**
 * __useMerlinSourceEventByIdQuery__
 *
 * To run a query within a React component, call `useMerlinSourceEventByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerlinSourceEventByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerlinSourceEventByIdQuery({
 *   variables: {
 *      sourceEventId: // value for 'sourceEventId'
 *   },
 * });
 */
export function useMerlinSourceEventByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MerlinSourceEventByIdQuery, MerlinSourceEventByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<MerlinSourceEventByIdQuery, MerlinSourceEventByIdQueryVariables>(MerlinSourceEventByIdDocument, baseOptions);
      }
export function useMerlinSourceEventByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MerlinSourceEventByIdQuery, MerlinSourceEventByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MerlinSourceEventByIdQuery, MerlinSourceEventByIdQueryVariables>(MerlinSourceEventByIdDocument, baseOptions);
        }
export type MerlinSourceEventByIdQueryHookResult = ReturnType<typeof useMerlinSourceEventByIdQuery>;
export type MerlinSourceEventByIdLazyQueryHookResult = ReturnType<typeof useMerlinSourceEventByIdLazyQuery>;
export type MerlinSourceEventByIdQueryResult = ApolloReactCommon.QueryResult<MerlinSourceEventByIdQuery, MerlinSourceEventByIdQueryVariables>;
export const ActiveCmsIntegrationsForSiteDocument = gql`
    query ActiveCmsIntegrationsForSite($siteId: UUID!) {
  activeCmsIntegrationsForSite(siteId: $siteId) {
    id
    resourceId
    vendor
    status
    config
    environmentVariablesFeatureStatus
    webhookFeatureStatus
    extensionFeatureStatus
  }
}
    `;

/**
 * __useActiveCmsIntegrationsForSiteQuery__
 *
 * To run a query within a React component, call `useActiveCmsIntegrationsForSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveCmsIntegrationsForSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveCmsIntegrationsForSiteQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useActiveCmsIntegrationsForSiteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActiveCmsIntegrationsForSiteQuery, ActiveCmsIntegrationsForSiteQueryVariables>) {
        return ApolloReactHooks.useQuery<ActiveCmsIntegrationsForSiteQuery, ActiveCmsIntegrationsForSiteQueryVariables>(ActiveCmsIntegrationsForSiteDocument, baseOptions);
      }
export function useActiveCmsIntegrationsForSiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActiveCmsIntegrationsForSiteQuery, ActiveCmsIntegrationsForSiteQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ActiveCmsIntegrationsForSiteQuery, ActiveCmsIntegrationsForSiteQueryVariables>(ActiveCmsIntegrationsForSiteDocument, baseOptions);
        }
export type ActiveCmsIntegrationsForSiteQueryHookResult = ReturnType<typeof useActiveCmsIntegrationsForSiteQuery>;
export type ActiveCmsIntegrationsForSiteLazyQueryHookResult = ReturnType<typeof useActiveCmsIntegrationsForSiteLazyQuery>;
export type ActiveCmsIntegrationsForSiteQueryResult = ApolloReactCommon.QueryResult<ActiveCmsIntegrationsForSiteQuery, ActiveCmsIntegrationsForSiteQueryVariables>;

  /**
   * __useMerlinSourceEventFragment__
   * To read a fragment data from Apollo Cache, call `useMerlinSourceEventFragment` and pass it the ID of the cached object.
   * When your component renders, `useMerlinSourceEventFragment` returns an object from Apollo Client cache that contains data property
   * you can use to render your UI.
   *
   * @param id a string representing the ID of the cached object that will be passed into the useApolloFragment
   *
   * @example
   * const { data } = useMerlinSourceEventFragment('fragment-id');
   */
export function useMerlinSourceEventFragment(id: string) {
          return useApolloFragment<MerlinSourceEventFragment>(MerlinSourceEventFragmentDoc, id);
        }
export type MerlinSourceEventFragmentHookResult = ReturnType<typeof useMerlinSourceEventFragment>;